export default class KykkaSizeConstants {
    public static readonly diameter = 75;
    public static readonly height = 100;
}